(function () {
  var TAG = 'qty-offers-component';
  if (customElements.get(TAG)) return;

  var chosen = null;

  function findSelector(root) {
    var scope = (root && root.closest('.shopify-section')) || document;
    return scope.querySelector('quantity-selector-component') || document.querySelector('quantity-selector-component');
  }
  function readQty(qs) {
    if (!qs) return null;
    var v = typeof qs.getValue === 'function' ? qs.getValue() : (qs.querySelector('input') || {}).value;
    return Number(v) || 1;
  }
  function writeQty(qs, n) {
    if (!qs) return;
    if (typeof qs.setValue === 'function') {
      qs.setValue(String(n));
      if (typeof qs.updateButtonStates === 'function') qs.updateButtonStates();
      if (typeof qs.onQuantityChange === 'function') qs.onQuantityChange();
    } else {
      var input = qs.querySelector('input');
      if (input) {
        input.value = String(n);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  class QtyOffers extends HTMLElement {
    connectedCallback() {
      var self = this;
      this._onChange = function (e) {
        var r = e.target && e.target.closest ? e.target.closest('.qo-radio') : null;
        if (!r) return;
        chosen = Number(r.value);
        writeQty(findSelector(self), chosen);
        self.sync();
      };
      this.addEventListener('change', this._onChange);

      var section = this.closest('.shopify-section');
      if (section && !section.__qoBound) {
        section.__qoBound = true;
        section.addEventListener('shopify:product:select', function (event) {
          Promise.resolve(event.promise).then(function (res) {
            var html = res && res.detail && res.detail.html;
            var pid = self.dataset.productId;
            var cur = section.querySelector(TAG);
            if (html && cur) {
              var fresh = html.querySelector(TAG + '[data-product-id="' + pid + '"]') || html.querySelector(TAG);
              if (fresh) cur.innerHTML = fresh.innerHTML;
            }
            var again = function () {
              var el = section.querySelector(TAG);
              if (!el) return;
              var qs = findSelector(el);
              if (chosen && readQty(qs) !== chosen) writeQty(qs, chosen);
              el.sync();
            };
            setTimeout(again, 80);
            setTimeout(again, 400);
          }).catch(function () {});
        });
      }

      this.sync();

      var flag = 'data-qo-init-' + this.dataset.productId;
      if (!document.documentElement.hasAttribute(flag)) {
        document.documentElement.setAttribute(flag, '1');
        var def = Number(this.dataset.default) || 1;
        customElements.whenDefined('quantity-selector-component').then(function () {
          var apply = function () {
            var qs = findSelector(self);
            if (qs && def > 1 && readQty(qs) === 1 && (chosen === null || chosen === def)) {
              chosen = def;
              writeQty(qs, def);
            }
            self.sync();
          };
          setTimeout(apply, 0);
          setTimeout(apply, 600);
        });
      }
    }
    disconnectedCallback() {
      this.removeEventListener('change', this._onChange);
    }
    sync() {
      var v = readQty(findSelector(this));
      this.querySelectorAll('.qo-card').forEach(function (card) {
        var on = Number(card.dataset.qty) === v;
        var s = on ? 'true' : 'false';
        if (card.dataset.selected !== s) card.dataset.selected = s;
        var r = card.querySelector('.qo-radio');
        if (r && r.checked !== on) r.checked = on;
      });
    }
  }
  customElements.define(TAG, QtyOffers);

  function syncAll() {
    document.querySelectorAll(TAG).forEach(function (el) { if (el.sync) el.sync(); });
  }
  ['click', 'input', 'change', 'keyup'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      if (t !== 'change' || !(e.target && e.target.closest && e.target.closest('.qo-radio'))) {
        var q = e.target && e.target.closest ? e.target.closest('quantity-selector-component') : null;
        if (q) {
          var n = readQty(q);
          if (n) chosen = n;
        }
      }
      setTimeout(syncAll, 0);
    }, true);
  });
})();
